export function CnpjValidation (value: any){
    
    if(String(value).length >= 8 && String(value).length <= 14) 
    {
        return true;
    }
    return false;
}